<template>
  <div>
    <el-dialog
      title="修改"
      :visible="isShowModifyDialog"
      width="30%"
      @close="handleDialog"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="订单状态" prop="toStatus">
          <el-select v-model="form.toStatus" placeholder="请选择订单状态">
            <el-option label="支付成功" value="01"></el-option>
            <el-option label="交易退还" value="04"></el-option>
            <el-option label="支付失败" value="02"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="msg">
          <el-input
            size="small"
            type="textarea"
            v-model="form.msg"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isShowModifyDialog: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        toStatus: '',
        msg: '',
      },
      rules: {
        toStatus: [
          { required: true, message: '请选择订单状态', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    handleDialog() {
      this.$refs['form'].resetFields()
      this.form = {
        toStatus: '',
        msg: '',
      }
      this.$emit('update:isShowModifyDialog', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const params = {
            ...this.form,
            orderId: this.id,
          }
          this.$axios.post('/order/updateOrderStatus', params).then(res => {
            if (res.code === 200) {
              this.$notify({
                title: '提示',
                message: res.msg,
                type: 'success',
              })
              this.$emit('update:isShowModifyDialog', false)
              // this.$bus.$emit('refresh') //通知刷新
            } else {
              this.$notify.error({
                title: '提示',
                message: res.msg,
              })
            }
          })
        }
      })
    },
  },
}
</script>